module.exports = __webpack_public_path__ + "static/img/mid-festival-icon.58fc194.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mid-festival-icon.png
// module id = M9oL
// module chunks = 1